export default classData => classData.grade === 'ProfessionalDevelopment'
